import type { ResultCode } from "@adyen/adyen-web";

import { useCheckoutContext } from "../../Checkout.hooks";
import CheckoutMessage from "../../CheckoutMessage";

export default function AdyenErrorMessage({
  resultCode,
  message,
}: {
  resultCode?: ResultCode;
  message?: string;
}) {
  const { dictionary } = useCheckoutContext();

  if (resultCode === "Refused") {
    return (
      <CheckoutMessage type="error">
        <h3 className="font-normal">
          {dictionary.adyenPaymentRefusedTitle ?? "Payment failed"}
        </h3>
        {dictionary.adyenPaymentRefusedText ??
          "Your payment was refused. Please try again or use another payment method."}
      </CheckoutMessage>
    );
  }

  if (resultCode === "Cancelled") {
    return (
      <CheckoutMessage type="error">
        <h3 className="font-normal">
          {dictionary.adyenPaymentCancelledTitle ?? "Payment cancelled"}
        </h3>
        {dictionary.adyenPaymentCancelledText ??
          "Your payment was cancelled. Please try again or use another payment method."}
      </CheckoutMessage>
    );
  }

  if (resultCode === "Error") {
    return (
      <CheckoutMessage type="error">
        <h3 className="font-normal">
          {dictionary.adyenPaymentErrorTitle ?? "Payment error"}
        </h3>
        {dictionary.adyenPaymentErrorText ??
          "An error occurred while processing your payment. Please try again or use another payment method."}
      </CheckoutMessage>
    );
  }

  if (message?.includes("Not Found")) {
    return (
      <CheckoutMessage type="error">
        {dictionary.adyenNotFoundError}
      </CheckoutMessage>
    );
  }

  return (
    <CheckoutMessage type="error">
      {message ?? dictionary.adyenUnknownError}
    </CheckoutMessage>
  );
}
